export const SPORTSBOOK_START = 'SPORTSBOOK:START';

export const startIntegration = () => ({
    type: SPORTSBOOK_START
});
